import { useTranslation } from "react-i18next";
import { Icon } from "../Icon";
import styles from "./IsPaidStatus.module.scss";

interface IsPaidStatusProps {
  paymentStatus: boolean;
}

export const IsPaidStatus: React.FC<IsPaidStatusProps> = ({ paymentStatus }) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.status} ${paymentStatus ? styles.paid : styles.unpaid}`}>
      <Icon name={paymentStatus ? "check" : "cross"} />
      <span className={styles.label}>{paymentStatus ? t("paid") : t("unpaid")}</span>
    </div>
  );
};

export default IsPaidStatus;
